export const OtherModulesLink = () => (
  <a href="/" className="cta-prominent">
    Interested in other Unum e-modules? Please click here
  </a>
);
